// extracted by mini-css-extract-plugin
export default {"timed":"TimedButton_timed__dIsen","bar":"TimedButton_bar__rp+5Z"};